import type { AppRouterOutputs } from '@framework/trpcClient';
import { atom } from 'jotai';

// AppRouterから型を推論してバックエンドAPIのレスポンス型を定義
type SidebarSearchOutput = AppRouterOutputs['sidebar']['search']['search'];
type SearchResponse = SidebarSearchOutput;

export type WorkspaceJSON = SidebarSearchOutput['results']['workspaces'][string];
export type FolderJSON = SidebarSearchOutput['results']['folders'][string];
export type ViewModelJSON = SidebarSearchOutput['results']['viewModels'][string];
export type ViewJSON = SidebarSearchOutput['results']['views'][string][number];

export const DEFAULT_SEARCH_RESULT: SearchResponse = {
  results: {
    workspaces: {},
    folderTrees: {},
    folders: {},
    viewModels: {},
    viewModelTags: {},
    views: {},
  },
  kataResults: {
    workspaces: {},
    folderTrees: {},
    folders: {},
    viewModels: {},
    viewModelTags: {},
    views: {},
  },
};

export const searchResultsAtom = atom<SearchResponse>(DEFAULT_SEARCH_RESULT);
export const includeViewsAtom = atom<boolean>(false);
export const isSearchingAtom = atom<boolean>(false);
